import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';

export default function MfaForm({ mfaToken, error, loading, onTokenChange, onBack, onSubmit }) {
    const handleSubmit = e => { e.preventDefault(); onSubmit(); };
    const handleChange = e => onTokenChange(e.target.value.replace(/[^0-9]/g, '').slice(0, 6));
    return (
        <form className="registration-form" onSubmit={handleSubmit}>
            <div className="form-group">
                <label htmlFor="login-mfa-token"><Translate id="STATIC.PAGES.LOGIN.MFA_LABEL" /></label>
                <input
                    id="login-mfa-token" type="text" className="form-control" placeholder="Authentication Token"
                    autoFocus maxLength={6} value={mfaToken} onChange={handleChange}
                />
            </div>
            {error ? <div className="text-danger">{error}</div> : null}
            <button type="submit" className="btn btn-block btn-singular btn-primary-singular" disabled={loading}>
                <Translate id="STATIC.PAGES.LOGIN.MFA_VERIFY" />
            </button>
            <div className="from-underlink-center-container">
                <a href="#" className="form-underlink" onClick={e => { e.preventDefault(); onBack(); }}>
                    <Translate id="STATIC.PAGES.LOGIN.BACK" />
                </a>
            </div>
        </form>
    );
}

MfaForm.propTypes = {
    mfaToken: PropTypes.string.isRequired,
    error: PropTypes.string.isRequired,
    loading: PropTypes.bool.isRequired,
    onTokenChange: PropTypes.func.isRequired,
    onBack: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
};
